import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { artAssets } from "../data/site";
import { Reveal } from "./Reveal";

export function WantedBreak() {
  return (
    <section className="wanted-break" data-testid="wanted-break-section">
      <Reveal className="wanted-break-inner">
        <figure className="wanted-break-frame">
          <img
            src={artAssets.wantedPoster}
            alt="R-Teddy Samurai unit blueprint — reinforced iron armor schematic"
            data-testid="wanted-break-image"
          />
        </figure>
        <div className="wanted-break-copy">
          <span>WANTED / NETWORK TRANSMISSION</span>
          <h2>DOLO IS MARKED ACROSS THE MULTIVERSE.</h2>
          <p>
            The official wanted artwork lands mid-journey as a warning shot before the TCG vault and archives open below.
          </p>
          <Link to="/character-book" className="text-link" data-testid="wanted-break-character-link">
            OPEN DOLO'S FILE <ArrowUpRight size={16} />
          </Link>
        </div>
      </Reveal>
    </section>
  );
}
